function createProgrammeWeek(name, mealsByDay) {
  return {
    name,
    days: mealsByDay
  };
}

export const programmeLibrary = [
  {
    id: "fat-loss-4",
    name: "4 Week Fat Loss",
    duration: "4 weeks",
    focus: "Fat loss",
    tags: ["Focused Vitality"],
    summary: "A structured high-protein plan designed to support gradual fat loss.",
    description:
      "A practical 4-week programme built around simple, filling meals with a high-protein focus. Designed to help reduce body fat while keeping planning easy and realistic.",
    weeks: [
      createProgrammeWeek("Week 1", {
        Monday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Tuesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Wednesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Thursday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Friday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Saturday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Sunday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" }
      }),
      createProgrammeWeek("Week 2", {
        Monday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Tuesday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Wednesday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Thursday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Friday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Saturday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Sunday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" }
      }),
      createProgrammeWeek("Week 3", {
        Monday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Tuesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Wednesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Thursday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Friday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Saturday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Sunday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" }
      }),
      createProgrammeWeek("Week 4", {
        Monday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Tuesday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Wednesday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Thursday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Friday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Saturday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" },
        Sunday: { breakfast: "Omelette", lunch: "Spaghetti Bolognese", dinner: "Chicken Stir Fry" }
      }),
    ]
  },
  {
    id: "high-protein-4",
    name: "4 Week High Protein Reset",
    duration: "4 weeks",
    focus: "High protein",
    tags: ["Powerful Balance"],
    summary: "A shorter reset plan built around easy high-protein meals.",
    description:
      "A simple 4-week programme for getting back into a steady meal-planning rhythm with protein-focused breakfasts, lunches, and dinners.",
    weeks: [
      createProgrammeWeek("Week 1", {
        Monday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Tuesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Wednesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Thursday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Friday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Saturday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Sunday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" }
      }),
      createProgrammeWeek("Week 2", {
        Monday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Tuesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Wednesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Thursday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Friday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Saturday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Sunday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" }
      }),
      createProgrammeWeek("Week 3", {
        Monday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Tuesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Wednesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Thursday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Friday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Saturday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" },
        Sunday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Chicken Stir Fry" }
      }),
      createProgrammeWeek("Week 4", {
        Monday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Tuesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Wednesday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Thursday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Friday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Saturday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" },
        Sunday: { breakfast: "Omelette", lunch: "Chicken Stir Fry", dinner: "Spaghetti Bolognese" }
      })
    ]
  },
];